__turbopack_context__.v({
  "buttonContainer": "readingSubmissionIntro-module-scss-module__ilCH2G__buttonContainer",
  "card": "readingSubmissionIntro-module-scss-module__ilCH2G__card",
  "cardContent": "readingSubmissionIntro-module-scss-module__ilCH2G__cardContent",
  "cardTitle": "readingSubmissionIntro-module-scss-module__ilCH2G__cardTitle",
  "clockIcon": "readingSubmissionIntro-module-scss-module__ilCH2G__clockIcon",
  "container": "readingSubmissionIntro-module-scss-module__ilCH2G__container",
  "error-msg": "readingSubmissionIntro-module-scss-module__ilCH2G__error-msg",
  "errorIcon": "readingSubmissionIntro-module-scss-module__ilCH2G__errorIcon",
  "hint": "readingSubmissionIntro-module-scss-module__ilCH2G__hint",
  "link": "readingSubmissionIntro-module-scss-module__ilCH2G__link",
  "list": "readingSubmissionIntro-module-scss-module__ilCH2G__list",
  "note": "readingSubmissionIntro-module-scss-module__ilCH2G__note",
  "section": "readingSubmissionIntro-module-scss-module__ilCH2G__section",
  "sectionTitle": "readingSubmissionIntro-module-scss-module__ilCH2G__sectionTitle",
  "timeEstimate": "readingSubmissionIntro-module-scss-module__ilCH2G__timeEstimate",
  "timeSubtext": "readingSubmissionIntro-module-scss-module__ilCH2G__timeSubtext",
  "timeText": "readingSubmissionIntro-module-scss-module__ilCH2G__timeText",
  "timeTextContainer": "readingSubmissionIntro-module-scss-module__ilCH2G__timeTextContainer",
  "title": "readingSubmissionIntro-module-scss-module__ilCH2G__title",
});
